import React from 'react';
import { bool, string, func } from 'prop-types';
import { Table, Label } from 'semantic-ui-react';

import { cap } from '~/utils';


const HeaderCell = ({
    field,
    sortByField,
    isSortReverse,
    handleSortChange,
    ...rest
}) => {
    const isActive = (sortByField === field);
    const icon = `long arrow alternate ${isSortReverse ? 'up' : 'down'}`;

    return (
        <Table.HeaderCell {...rest}>
            <Label
                basic
                as="a"
                size="large"
                content={cap(field)}
                color={isActive ? 'black' : undefined}
                icon={isActive ? icon : undefined}
                onClick={() => handleSortChange(field)}
            />
        </Table.HeaderCell>
    );
};

HeaderCell.propTypes = {
    field: string.isRequired,
    sortByField: string.isRequired,
    isSortReverse: bool.isRequired,
    handleSortChange: func.isRequired,
};

export default HeaderCell;
